
import { BookkeepingService, BrowseService, ToolbarService } from "@/services";
import Vue from "vue";
import AppBrowse from "@/components/browse/Browse.vue";
import { IBrowseDataSource } from "@/utils/browse/browse-data-source";
import { Bookkeeping } from "@/models/bookkeeping/bookkeeping";
import { BrowseID } from "@/models/browse";
import { IQueryParams } from "@/utils/query-params";
import { BrowsePermissions } from "@/models/user-configs/browse-permissions";
import { View } from "@/models/view";
import { FetchedTotal } from "@/utils/views/fetched-total";
import { ISelectItem } from "winfakt-vue-components";
import AppCreateBookkeepingDataModal from "@/components/bookkeeping/CreateBookkeepingDataModal.vue";
import { MODULE } from "@/config/modules";
import { checkHasModule } from "@/router";

export default Vue.extend({
	data(){
		return {
			selectedItems: [] as Bookkeeping[],
			createDataModal: false
		};
	},
	computed: {
		dataSource():IBrowseDataSource<Bookkeeping>{
			return {
				getSettings: () => BrowseService.getBrowse(BrowseID.BOOKKEEPING),
				getElements: async (params: IQueryParams) => {
					return BookkeepingService.getBookkeeping(params);
				},
				getFullElement (el: Bookkeeping): Promise<Bookkeeping> {
					throw new Error("Function not implemented.");
				},
				addRoute: "",
				edit (element: Bookkeeping) {
					return;
				},
				async delete(elements: Bookkeeping[]): Promise<boolean> {
					return false;
				},
				browsePermissions (): BrowsePermissions {
					throw new Error("Function not implemented.");
				},
				modelName: "Bookkeeping",
				browseName: "Bookkeeping",
				getTotals (view: View): Promise<FetchedTotal[]> {
					throw new Error("Function not implemented.");
				}
			};
		},
		buttonBarItems():ISelectItem<Function>[]{
			return [
				{
					text: this.$ct("create-bookkeeping-data"),
					value: ()=>this.createDataModal = true,
					icon: "play"
				}
			];
		}
	},

	created(){
		if (!checkHasModule(MODULE.BOEKHOUDLIJSTEN, this.$router)){
			this.$router.push(`/missing-module/${MODULE.BOEKHOUDLIJSTEN}`);
		}
	},
	mounted() {
		ToolbarService.title = this.$ct("bookkeeping-result");
	},
	components: {
		AppBrowse,
		AppCreateBookkeepingDataModal
	},
	i18nEx: {
		componentPrefix: "components.bookkeeping"
	}
});
